import styles from '../../assets/scss/components/collections/collection-card.module.scss'
import { Image, Link } from '@shopify/hydrogen'
import { Collection } from '@shopify/hydrogen/storefront-api-types'
import { FC } from 'react'
import { useI18n } from '../i18n.client'
import { classNames } from '@shopify/css-utilities'

export const CollectionCard: FC<{ collection: Collection; variant?: string }> = ({ collection, variant = '' }) => {
  const [i18n] = useI18n()

  return (
    <Link className={classNames(styles.card, styles[variant])} to={`/collections/${collection.handle}`}>
      <CollectionImage collection={collection} />
      <div className={styles.title}>{collection.title}</div>
      <div className={styles.button}>{i18n.translate('shop-the-collection')}</div>
    </Link>
  )
}

const CollectionImage: FC<{ collection: Collection }> = ({ collection }) => {
  if (collection.image) {
    return (
      <Image
        className={classNames('fit-width', styles.image)}
        data={collection.image}
        alt={collection.image.altText || collection.title}
      />
    )
  }

  return (
    <Image
      alt=""
      className={classNames('fit-width', styles.image)}
      height="1280"
      src="https://dummyimage.com/844x1280"
      width="844"
    />
  )
}
